import type { FC } from 'react';
import DataTable from './DataTable';
export * from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default DataTable as FC<Record<string, any>>;
